import { toast } from "react-toastify";
import { call, fork, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* createVideoVoucher({ payload }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.createVideoVouchers);
    yield put(actions.createVideoVouchersSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    yield put(actions.createVideoVouchersFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* getAllVideos({ payload }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.getAllVideos, payload);
    yield put(actions.getAllVideosSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getAllVideosFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* getPaymentSubject({ payload }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.getPaymentSubjects, payload);
    yield put(actions.getPaymentSubjectSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getPaymentSubjectFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* addPaymentSubject({ payload, action }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.addPaymentSubject, payload);
    yield put(actions.addPaymentSubjectSuccess(result.data));
    toast.success("Created Successfully");   
    action && action();
  }
  catch (error) {
    toast.error(error);
    yield put(actions.addPaymentSubjectFail()); 
  }
  finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* editPaymentSubject({ payload }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.editPaymentSubject, payload);
    yield put(actions.editPaymentSubjectSuccess(result.data));
    toast.success("Created Successfully");
    payload?.action && payload?.action();
  }
  catch (error) {
    toast.error(error);
    yield put(actions.editPaymentSubjectFail());
  }
  finally {
    yield put(actions.addVideoLoading(false));
  }
}

//Edit Tables
function* editVideo({ payload }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.editVideos, payload);
    yield put(actions.editVideoSuccess(result.data));
    toast.success("Edit Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.editVideoFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* suspendVideo({ payload }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.suspendVideos, payload);
    yield put(actions.suspendVideoSuccess(result.data));
  } catch (error) {
    yield put(actions.suspendVideoFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

// create
function* createVideo(formData) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.createVideo, formData.payload);
    yield put(
      actions.createVideoSuccess({
        data: result.data,
      })
    );
    toast.success("Created Successfully");
    formData?.action && formData?.action(1);
  } catch (error) {
    yield put(actions.createVideoFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* addVideoFiles(formData) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.addVideoFiles, formData.payload);
    yield put(
      actions.addVideoFilesSuccess({
        data: result.data,
      })
    );
    toast.success("Created Successfully");
    formData?.action && formData?.action(result?.data?.data?.id);
  } catch (error) {
    toast.success("Created Successfully");
    yield put(actions.addVideoFilesFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* deleteVideoFile({ payload }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.deleteVideoFile, payload);

    yield put(actions.deleteVideoFilesSuccess(payload));

    toast.success("Deleted Successfully");
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response);
    yield put(actions.deleteVideoFilesFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* deleteVideo({ payload }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.deleteVideo, payload);

    yield put(actions.deleteVideoSuccess(payload));

    toast.success("Deleted Successfully");
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response);
    yield put(actions.deleteVideoFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* fixViewsCount(){
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.fixViewsCount);
    yield put(actions.fixViewsCountSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response);
    yield put(actions.fixViewsCountFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* getUserVideos({ payload }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.getUserVideos, payload);
    yield put(actions.getUserVideosSuccess(result.data));
  }
  catch (error) {
    toast.error(error.response?.data?.message || "حدث خطأ أثناء جلب البيانات");
    yield put(actions.getUserVideosFail());
  }
  finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* addView({ payload }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.addView, payload);
    yield put(actions.addViewSuccess(result.data));
    toast.success("تم إضافة المشاهدة بنجاح");
  }
  catch (error) {
    toast.error(error.response?.data?.message || "حدث خطأ أثناء إضافة المشاهدة");
    yield put(actions.addViewFail());
  }
  finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* getVideoVdoChapters({ payload }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.getVideoVdoChapters, payload);
    yield put(actions.getVideoVdoChaptersSuccess(result.data));
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to load chapters"
    );
    yield put(actions.getVideoVdoChaptersFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* updateVideoVdoChapters({ payload, action }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(
      api.updateVideoVdoChapters,
      payload.id,
      payload.body
    );
    yield put(actions.updateVideoVdoChaptersSuccess(result.data));
    toast.success("Chapters updated");
    action && action();
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to update chapters"
    );
    yield put(actions.updateVideoVdoChaptersFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

function* addVideoQuestion({ payload, action }) {
  try {
    yield put(actions.addVideoLoading(true));
    const result = yield call(api.addVideoQuestion, payload);
    yield put(actions.addVideoQuestionSuccess(result.data));
    toast.success("تم حفظ سؤال الفيديو");
    action && action();
  } catch (error) {
    toast.error(error.response?.data?.message || "فشل حفظ سؤال الفيديو");
    yield put(actions.addVideoQuestionFail());
  } finally {
    yield put(actions.addVideoLoading(false));
  }
}

export default function* VideoSaga() {
  yield takeLatest(Types.GET_VIDEOS_REQUEST, getAllVideos);
  yield takeLatest(Types.CREATE_VIDEO_VOUCHERS_REQUEST, createVideoVoucher);

  yield takeLatest(Types.EDIT_VIDEO_REQUEST, editVideo);
  yield takeLatest(Types.SUSPEND_VIDEO_REQUEST, suspendVideo);
  yield takeLatest(Types.CREATE_VIDEO_REQUEST, createVideo);
  yield takeLatest(Types.ADD_VIDEO_FILES_REQUEST, addVideoFiles);
  yield takeLatest(Types.DELETE_VIDEO_FILES_REQUEST, deleteVideoFile);
  yield takeLatest(Types.DELETE_VIDEO_REQUEST, deleteVideo);
  yield takeLatest(Types.GET_PAYMENT_SUBJECT_REQUEST, getPaymentSubject);
  yield takeLatest(Types.FIX_VIEWS_COUNT_REQUEST, fixViewsCount);
  yield takeLatest(Types.ADD_PAYMENT_SUBJECT_REQUEST, addPaymentSubject);
  yield takeLatest(Types.EDIT_PAYMENT_SUBJECT_REQUEST, editPaymentSubject);
  yield takeLatest(Types.GET_USER_VIDEOS_REQUEST, getUserVideos);
  yield takeLatest(Types.ADD_VIEW_REQUEST, addView);
  yield takeLatest(Types.GET_VIDEO_VDO_CHAPTERS_REQUEST, getVideoVdoChapters);
  yield takeLatest(Types.UPDATE_VIDEO_VDO_CHAPTERS_REQUEST, updateVideoVdoChapters);
  yield takeLatest(Types.ADD_VIDEO_QUESTION_REQUEST, addVideoQuestion);
}
